<app-menu-toggle
  tooltip="See full event display"
  icon="link"
  (click)="goToExperiment()"
></app-menu-toggle>
